import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import TabsNavigation from './TabsNavigation'
import { Clear as CloseButtton } from '@material-ui/icons'
import { NotFound } from 'src/pages/NotFound'
import { useStyles } from './styles'
import { IAnimal } from 'src/dto/animal.dto'

interface AnimalDetailsContentProps {
  isOpen: boolean
  isLoading: boolean
  isNotFound?: boolean
  data?: IAnimal
  handleOpenModal: (value: boolean) => void
  handleCloseModal: () => void
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='left' ref={ref} {...props} />
})

export const AnimalDetails: React.FC<AnimalDetailsContentProps> = ({
  isOpen,
  isLoading,
  isNotFound,
  data,
  handleCloseModal
}) => {
  const styles = useStyles()

  return (
    <div>
      <Dialog
        className={styles.animalDetailsContainer}
        open={isOpen}
        TransitionComponent={Transition as any}
        keepMounted
        onClose={handleCloseModal}
        PaperProps={{
          className: styles.animalDetailsModdal as string
        }}
      >
        <DialogContent style={{ padding: 0 }}>
          <div className={styles.viewMainContainer}>
            <div className={styles.headerButtonContainer}>
              <CloseButtton className={styles.closeButtonIcon} onClick={handleCloseModal} />
            </div>
            {isNotFound && !isLoading ? (
              <NotFound
                title='Animal não encontrado'
                description='Este animal foi removido ou não existe mais no sistema.'
                buttonLabel='Voltar'
                onAction={handleCloseModal}
              />
            ) : (
              <TabsNavigation aimalData={data} isLoading={isLoading} handleCloseModal={handleCloseModal} />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}
